import { render, staticRenderFns } from "./UiTelegramEditor.vue?vue&type=template&id=b3fe37c8&"
import script from "./UiTelegramEditor.vue?vue&type=script&lang=js&"
export * from "./UiTelegramEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports